/**
 * Method: GET
 */
import { OutputBase } from "./common/OutputBase";
import { InputBase } from "./common/InputBase";
import { ItemType } from "../lib/ItemType";
import { TypeObstruction } from "./common/TypeObstruction";
import { TypePanelRow } from "./common/TypePanelRow";

class RoofPlanGetInput extends InputBase {
	id: number;
}

class RoofPlanGetOutput extends OutputBase {

	ok: {
		data: RoofPlanGetData
	}
	error: {
	}
}

export class RoofPlanGetData {
	id: number;
	projectID: number;
	name: string;
	windZone: string;
	snowZone: string;
	terrainCategory: string;
	terrainHeight: number;
	buildingHeight: number;
	roofType: number;
	roofShape: number;
	roofPitch: number;
	roofA: number;
	roofB: number;
	roofC: number;
	roofD: number;
	roofOrientation: number;
	roofObstructions?: TypeObstruction[];
	panelCount: number;
	totalCapacity: number;
	projectPanel?: boolean;
	panelID: number;
	panelRows: TypePanelRow[];
	items: ItemType[];
	noEdges: boolean;
	cantileverValid: boolean;
	mountSystem: number;
	mountType: number;
	mountColor: number;
	battenDivision: number;
	purlinMaterial: number;
	roofHookBasePlate: number;
	roofHookType: number;
	hProfile: string;
	profileLength: number;
	hangerBolt: string;
	beamType: number;
	beamSpace: number;
	beamFirst: number;
	trapezMaterial: number;
	trapezTopChord: number;
	trapezBottomChord: number;
	trapezCalotteSize: number;
	trapezProfileHeight: number;
	trapezHighBeadingSpace: number;
	trapezThickness: number;
	adhesiveTapeColor: string;
	/**
	 * Only needed for PDF
	 */
	calculatedStatics: RoofPlanGetStaticsType;
	invalid: boolean;
	version: number;
	overviewPanelImg?: Blob;
	overviewSubframeImg?: Blob;
	overviewSubframeProfileCutImg?: Blob;
}

export class RoofPlanGetStaticsType {
	snowLoadF: number;
	snowLoadG: number;
	snowLoadH: number;
	/**
	 * in Pa (Pascal)
	 */
	windLoadF: number;
	windLoadG: number;
	windLoadH: number;
	/**
	 * in Pa (Pascal)
	 */
	totalPressureF: number;
	totalPressureG: number;
	totalPressureH: number;
	/**
	 * in Pa (Pascal)
	 */
	suctionF: number;
	suctionG: number;
	suctionH: number;
	/**
	 * in cm
	 */
	maxSpanWidthPortraitF: number;
	maxSpanWidthPortraitG: number;
	maxSpanWidthPortraitH: number;
	/**
	 * in cm
	 */
	maxSpanWidthLandscapeF: number;
	maxSpanWidthLandscapeG: number;
	maxSpanWidthLandscapeH: number;
	/**
	 * in cm
	 */
	minCantileverPortraitF: number;
	minCantileverPortraitG: number;
	minCantileverPortraitH: number;
	/**
	 * in cm
	 */
	minCantileverLandscapeF: number;
	minCantileverLandscapeG: number;
	minCantileverLandscapeH: number;
	/**
	 * in cm
	 */
	maxCantileverPortraitF: number;
	maxCantileverPortraitG: number;
	maxCantileverPortraitH: number;
	/**
	 * in cm
	 */
	maxCantileverLandscapeF: number;
	maxCantileverLandscapeG: number;
	maxCantileverLandscapeH: number;
}